import React, {PureComponent} from 'react';

import AggregateExpression from './AggregateExpression';
import CreateExpression from './CreateExpression';
import CompareExpression from './CompareExpression';
import DateCompareExpression from './DateCompareExpression';
import LogicExpression from './LogicExpression';
import MathExpression from './MathExpression';
import ValidationExpression from './ValidationExpression';
import Terminal from './Terminal';
import Bracket from './Bracket';

class JsonLogicBuilder extends PureComponent {
  state = {
    expanded: this.props.expand
  };

  handleExpandExpression(e) {
    e.preventDefault();
    e.stopPropagation();
    this.setState({expanded: true});
  }

  handleCollapseExpression(e) {
    e.stopPropagation();
    this.setState({expanded: false});
  }

  render() {
    const {value, parentType} = this.props;
    const {expanded} = this.state;

    if(value === null || typeof value === 'undefined') {
      return <CreateExpression {...this.props} parentType={parentType} />;
    }

    if(isTerminal(value)) {
      return <Terminal {...this.props} />;
    }

    const operator = Object.keys(value)[0];
    const childValue = value[operator];

    if(!expanded) {
      return (
        <Bracket>
          <button onClick={this.handleExpandExpression.bind(this)} style={styles.expand}>&hellip;</button>
        </Bracket>
      );
    }

    switch(operator) {
      case '==':
      case '!=':
      case '>=':
      case '<=':
      case '<':
      case '>':
      case 'search_list':
      case 'in':
      case 'some_>':
      case 'some_>=':
      case 'some_<':
      case 'some_<=':
      case 'some_==':
      case 'some_!=':
      case 'all_>':
      case 'all_>=':
      case 'all_<':
      case 'all_<=':
      case 'all_==':
      case 'all_!=':
      case 'sum_>':
      case 'sum_>=':
      case 'sum_<':
      case 'sum_<=':
      case 'sum_==':
      case 'avg_>':
      case 'avg_>=':
      case 'avg_<':
      case 'avg_<=':
      case 'avg_==':
        return (
          <CompareExpression
            {...this.props}
            value={childValue}
            operator={operator}
            onCollapse={this.handleCollapseExpression.bind(this)}
          />
        );
      case 'and':
      case 'or':
        return (
          <LogicExpression
            {...this.props}
            value={childValue}
            operator={operator}
            onCollapse={this.handleCollapseExpression.bind(this)}
          />
        );
      case '+':
      case '-':
      case '*':
      case '/':
      case '%':
        return (
          <MathExpression
            {...this.props}
            value={childValue}
            operator={operator}
            onCollapse={this.handleCollapseExpression.bind(this)}
          />
        );
      case 'agg_sum':
      case 'agg_avg':
      case 'agg_min':
      case 'agg_max':
        return (
          <AggregateExpression
            {...this.props}
            value={childValue}
            operator={operator}
            onCollapse={this.handleCollapseExpression.bind(this)}
          />
        );
      case 'datetime_after':
      case 'datetime_before':
      case 'datetime_equal':
      case 'time_after':
      case 'time_before':
      case 'time_equal':
        return (
          <DateCompareExpression
            {...this.props}
            value={childValue}
            operator={operator}
            onCollapse={this.handleCollapseExpression.bind(this)}
          />
        );
      case '!':
      case '!!':
        return (
          <ValidationExpression
            {...this.props}
            value={childValue}
            operator={operator}
            onCollapse={this.handleCollapseExpression.bind(this)}
          />
        );
      default:
        throw new Error('Unhandled operator: ' + operator);
    }
  }
}

function isPrimitive(value) {
  return typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean';
}

function isVariable(value) {
  return value && !!value.var;
}

function isTerminal(value) {
  return isPrimitive(value) || isVariable(value);
}

const styles = {
  expand: {
    textDecoration: 'none',
    fontSize: 20,
    background: 'none',
    border: 0,
    padding: 0,
    margin: 0,
    color: '#001e62',
    cursor: 'pointer'
  }
};

export default JsonLogicBuilder;
